import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import CreateCategoryIcon from '@material-ui/icons/Add'
import CreateFolderIcon from '@material-ui/icons/CreateNewFolder'

import EditIcon from '@material-ui/icons/Ballot'
import DeleteIcon from '@material-ui/icons/DeleteForever'

import PaperBlock from "../../ui/PaperBlock"

/**
 * <ControlPanel selected onCreateFolderClick = {} onCreateCategoryClick = {} onEditItemClick = {item} onDeleteItemClick = {item}/>
 */

class CategoryScreenControlPanel extends Component {

	render() {

		return <PaperBlock style = {{display: "flex"}}>

			<Tooltip title = "Создать папку"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateFolderClick === "function") {
							this.props.onCreateFolderClick()
						}
					}}
				>
					<CreateFolderIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Создать категорию"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCreateCategoryClick === "function") {
							this.props.onCreateCategoryClick()
						}
					}}
				>
					<CreateCategoryIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Редактировать"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditItemClick === "function") {
							this.props.onEditItemClick(this.props.selected)
						}
					}}
				>
					<EditIcon />
					</Button>
			</div></Tooltip>

			<Tooltip title = "Удалить"><div>
				<Button
					disabled = {!this.props.selected}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onDeleteItemClick === "function") {
							this.props.onDeleteItemClick(this.props.selected)
						}
					}}
				>
					<DeleteIcon />
				</Button>
			</div></Tooltip>

		</PaperBlock>

	}

}

export default CategoryScreenControlPanel
